import { computed } from 'vue';

export default function useEditorToolbar({ editor, disabled, setLink, toggleHighlightMenu, toggleTextColorMenu }) {
  let keyboard_handler = null;

  const toolbarItems = computed(() => {
    if (!editor.value) return [];

    return [
      {
        name: 'bold',
        icon: ['far', 'bold'],
        isActive: editor.value.isActive('bold'),
        action: () => editor.value.chain().toggleBold().focus().run(),
      },
      {
        name: 'italic',
        icon: ['far', 'italic'],
        isActive: editor.value.isActive('italic'),
        action: () => editor.value.chain().toggleItalic().focus().run(),
      },
      {
        name: 'strike',
        icon: ['far', 'strikethrough'],
        isActive: editor.value.isActive('strike'),
        action: () => editor.value.chain().toggleStrike().focus().run(),
      },
      {
        name: 'underline',
        icon: ['far', 'underline'],
        isActive: editor.value.isActive('underline'),
        action: () => editor.value.chain().toggleUnderline().focus().run(),
      },
      {
        name: 'highlight',
        icon: ['far', 'highlighter'],
        isActive: editor.value.isActive('highlight'),
        action: (event) => toggleHighlightMenu(event),
      },
      {
        name: 'textColor',
        icon: ['far', 'palette'],
        isActive: editor.value.isActive('textStyle'),
        action: (event) => toggleTextColorMenu(event),
      },
      {
        name: 'bulletList',
        icon: ['far', 'list'],
        isActive: editor.value.isActive('bulletList'),
        action: () => editor.value.chain().toggleBulletList().focus().run(),
      },
      {
        name: 'orderedList',
        icon: ['far', 'list-ol'],
        isActive: editor.value.isActive('orderedList'),
        action: () => editor.value.chain().toggleOrderedList().focus().run(),
      },
      {
        name: 'link',
        icon: ['far', 'link'],
        isActive: false,
        action: () => setLink(),
      },
      {
        name: 'unlink',
        icon: ['fas', 'link-slash'],
        isActive: false,
        disabled: !editor.value.isActive('link'),
        action: () => editor.value.chain().focus().unsetLink().run(),
      },
      {
        name: 'undo',
        icon: ['far', 'rotate-left'],
        isActive: false,
        action: () => editor.value.commands.undo(),
      },
      {
        name: 'redo',
        icon: ['far', 'rotate-right'],
        isActive: false,
        action: () => editor.value.commands.redo(),
      },
    ];
  });

  function setupKeyboardShortcuts() {
    keyboard_handler = (event) => {
      if (!editor.value || disabled.value) return;

      if (event.ctrlKey || event.metaKey) {
        switch (event.key) {
          case 'b':
            event.preventDefault();
            editor.value.chain().toggleBold().focus().run();
            break;
          case 'i':
            event.preventDefault();
            editor.value.chain().toggleItalic().focus().run();
            break;
          default:
            break;
        }
      }
    };

    document.addEventListener('keydown', keyboard_handler);
  }

  function cleanupKeyboardShortcuts() {
    if (keyboard_handler) {
      document.removeEventListener('keydown', keyboard_handler);
    }
  }

  return {
    toolbarItems,
    setupKeyboardShortcuts,
    cleanupKeyboardShortcuts,
  };
}
